import * as defaultImport from "@splunk/react-icons/ChevronsOut";
export * from "@splunk/react-icons/ChevronsOut";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
